export default {
  tabs: {
    profile: 'Profil',
    branding: 'Branding',
    domain: 'Domæne',
    earning: 'Indtjening',
    feature_flags: 'Funktionsflag',
    notification_channels: 'Notifikationskanaler',
    pricing: 'Priser',
    fees: 'Gebyrer',
    payments: 'Betalinger',
    billing: 'Fakturering',
  },
  earning: {
    internal_notice: 'Kun indstillinger for FoodAmigos. Ikke synlige for partneren.',
    read_only_notice: 'Skrivebeskyttet. Klik på Rediger for at ændre værdier.',
    editing_notice: 'Redigerer – ændringer påvirker de faktiske udbetalingsberegninger.',
  },
  fees: {
    internal_notice:
      'Kun indstillinger for FoodAmigos. Ikke synlige for partneren, og kun superadministratorer kan åbne denne fane. Ændringer påvirker, hvad gæsterne opkræves, og hvad platformen tjener.',
    read_only_notice: 'Skrivebeskyttet. Klik på Rediger for at ændre værdier på denne fane.',
    editing_notice:
      'Redigerer – Gem skriver både servicegebyret og behandlingssatserne. Satserne gælder fra næste betaling; tidligere transaktioner beholder den margen, der er registreret på dem.',
  },
  profile: {
    read_only_notice: 'Skrivebeskyttet. Klik på Rediger for at ændre værdier.',
    editing_notice: 'Redigerer – visningsnavnet er synligt for forbrugerne.',
    form: {
      name: {
        label: 'Partnernavn',
        hint: 'Det juridiske navn / virksomhedsnavn. Bruges internt og på faktureringsdokumenter.',
      },
      display_name: {
        label: 'Visningsnavn for forbrugere',
        hint: 'Etiketten „Powered by ___“, som vises til kunderne. Bruger partnernavnet, hvis feltet er tomt.',
      },
      admin_email: {
        label: 'Admin-e-mail',
        hint: 'Den inviterede administratorkonto. Kan ikke ændres her – kontakt engineering for at flytte kontoen.',
      },
      invoicing_emails: {
        label: 'Faktura-e-mails',
        hint: 'Kvitteringer for fakturaer, der faktureres til denne partner, sendes til hver af disse adresser. Lad feltet stå tomt for at bruge administratorens e-mail.',
        placeholder: 'Admin-e-mail',
      },
      status: {
        label: 'Status',
        hint: 'Inviterede partnere bliver aktive ved deres første login – manuel aktivering springer det over. Suspendering deaktiverer alle partnerens teamlogins.',
      },
      region: {
        label: 'Region',
        hint: 'Landet er fastlagt. Vælg en delstat, når partnerens restauranter følger skatteregler på delstatsniveau – det ændrer kun partnerens standarder, ikke eksisterende restauranter.',
      },
      messenger_audience: {
        label: 'Supportchat',
        hint: "Hvem under denne partner der får FoodAmigos' supportchat. FoodAmigos-personale har den altid. White label-partnere supporterer deres egne restauranter, så kun deres administratorer får den.",
        options: {
          everyone: 'Alle, inklusive restauranter',
          partner_admins: 'Kun partneradministratorer',
          nobody: 'Ingen',
        },
      },
      shop_domains: {
        label: 'Shopdomæner',
        hint: 'Rodomæner, som partnerens restaurantshops vises på. Det primære domæne bruges til nye brands. Partneren forbinder og fjerner selv sine shopdomæner; fanen Domæne viser deres DNS-records.',
      },
    },
    region: {
      whole_country: 'Hele landet',
    },
    shop_domains: {
      primary: 'Primær',
      platform_default: 'Platformstandard',
      empty: 'Intet shopdomæne er tilknyttet endnu',
    },
    statuses: {
      invited: 'Inviteret',
      active: 'Aktiv',
      suspended: 'Suspenderet',
    },
    custody: {
      label: 'Betalingsbehandling',
      not_configured: 'Endnu ikke konfigureret',
      provider: 'Partnerens egen gateway',
      platform: 'FoodAmigos behandler betalinger',
      bank_account: {
        set: 'Bankkonto: {{label}} ({{status}})',
        missing: 'Ingen bankkonto endnu. Partneren angiver den under Partnerfakturering.',
        statuses: {
          active: 'aktiv',
          pending_verification: 'under verificering',
          action_needed: 'handling påkrævet',
          errored: 'udbetaling mislykkedes',
          missing: 'mangler',
        },
      },
      hint: 'Bestemmes af betalingskonfigurationen på fanen Betalinger og låses, når en betalingskanal er gemt. Under FoodAmigos-behandling udbetales partnerens indtægtsandel månedligt.',
      kyc: {
        label: 'Udbetalingskonto',
        missing: 'Endnu ikke oprettet',
        incomplete: 'Verificering ikke fuldført',
        complete: 'Klar til udbetalinger',
        currently_due: 'Stripe mangler stadig: {{fields}}',
        send_link: 'Send onboarding-link',
        link_copied:
          'Onboarding-linket er kopieret til udklipsholderen – send det videre til partneren. Det kan kun bruges én gang og udløber.',
        link_ready: 'Onboarding-link – send det videre til partneren (engangslink, udløber)',
        link_failed: 'Onboarding-linket kunne ikke oprettes.',
      },
    },
    suspend_confirm: {
      title: 'Suspendér denne partner?',
      description:
        'Alle partnerens teammedlemmer deaktiveres, og deres sessioner tilbagekaldes. Deres restauranter forbliver live.',
    },
  },
  branding: {
    read_only_notice: 'Skrivebeskyttet. Klik på Rediger for at ændre værdier.',
    editing_notice: 'Redigerer – ændringer er synlige på partnerens white label-flader.',
    upload: 'Upload logo',
    logo: {
      label: 'Logo',
      hint: 'Vises på partnerens white label-flader.',
    },
    circle_logo: {
      label: 'Favicon / rundt logo',
      hint: 'Kvadratisk logo, der bruges som favicon og avatar. Valgfrit – kan fjernes.',
    },
    splash_image: {
      label: 'Loginbillede',
      hint: 'Fylder venstre halvdel af partnerens white label-loginside helt ud til kanterne (beskåret til at dække). Anbefalet: portrætkomposition, mindst 1200×1200 px. Valgfrit – kan fjernes.',
    },
    footer_note: 'Flere brandingmuligheder (sekundære farver) kommer senere.',
  },
  revenue_split: {
    title: 'Indtægtsdeling',
    description:
      'Angiv partnerens andel af hvert gebyr, som FoodAmigos opkræver på deres restauranters ordrer. Standard er 0 % – FoodAmigos beholder hele gebyret, indtil der tildeles en andel. Udbetales hver faktureringsperiode.',
    manage_on_fees: 'Administrér under fanen Gebyrer',
    split: 'Partner {{partner}} % · FoodAmigos {{platform}} %',
    rows: {
      processing: 'Behandlingsgebyrer',
      gift_card: 'Gavekortgebyr',
      delivery: 'Leveringsgebyrer',
      service_fee: 'Servicegebyr',
    },
    notes: {
      service_fee: 'Det beløb, der opkræves af gæsterne, indstilles under Kontrol af servicegebyr på fanen Gebyrer.',
    },
  },
  service_fee_controls: {
    title: 'Kontrol af servicegebyr',
    description: 'Hvad partneren opkræver sine gæster i servicegebyr oven i bestillingen.',
    zero_percentage_warning:
      'En procentsats på 0 % deaktiverer ikke servicegebyret: beregnede gebyrer under minimumsbeløbet rundes op til det, så hver bestilling stadig opkræves mindst minimumsbeløbet.',
  },
  hard_limits: {
    title: 'Hårde grænser',
    description:
      'FoodAmigos-lofter, der håndhæves ved lagring og ved betaling. Intet servicegebyr hos denne partner – heller ikke restaurantspecifikke tilsidesættelser – må overstige disse.',
    max_percentage: {
      label: 'Maksimalt servicegebyr i %',
      help: 'Partnerens servicegebyr kan ikke sættes højere end dette. Platformens grænse: 5 %.',
    },
    min_amount: {
      label: 'Minimumsbeløb for servicegebyr',
      help: 'Minimumsbeløb pr. restaurant kan ikke sættes lavere end dette beløb.',
    },
    max_amount: {
      label: 'Maksimumsbeløb for servicegebyr',
      help: 'Absolut loft for det faste servicegebyr, uanset procentsats.',
    },
  },
  form: {
    charges_service_fee_on_site: {
      label: 'Opkræv servicegebyr på bordbestillinger',
      description:
        'Standarden for denne partners restauranter; hver kan indstille sin egen. Fra: bordbestillinger betaler ikke servicegebyr.',
    },
    is_service_fee_change_allowed: {
      label: 'Tillad ændring af servicegebyr pr. restaurant',
      description: 'Gør det muligt for partnerens enkelte restauranter at bruge et andet servicegebyr.',
    },
    service_fee_platform_share: {
      label: "Foodamigos' andel af servicegebyret",
    },
    recommended: 'Anbefalet: {{value}}',
    service_fee_percentage: {
      label: 'Standardprocent for servicegebyr',
      help: 'Gælder for hver af partnerens restauranter, medmindre den tilsidesættes.',
    },
    min_service_fee_amount: {
      label: 'Standard minimumsgebyr',
      help: "Standardminimum pr. bestilling – beregnede gebyrer under dette rundes op. Restauranter kan angive deres eget inden for FoodAmigos' grænser.",
    },
    max_service_fee_amount: {
      label: 'Standard maksimumsgebyr',
      help: "Standardloft pr. bestilling – restauranter kan angive deres eget inden for FoodAmigos' grænser.",
    },
    primary_color: {
      label: 'Primær brandfarve',
    },
    dashboard_subdomain: {
      label: 'Partnerens login-slug',
      hint: 'Slug med små bogstaver – identificerer partnerens brand i dens teamlogin-link (?partner=…).',
      placeholder: 'partnernavn',
    },
    login_url: {
      label: 'Teamlogin-link',
      hint: 'Linket, som partnerens team bruger til at nå sin brandede loginside.',
    },
    file: {
      label: 'Billede',
    },
  },
  buttons: {
    edit: 'Rediger',
    cancel: 'Annuller',
    save: 'Gem',
  },
  toasts: {
    load_error: 'Indstillingerne kunne ikke indlæses.',
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
    logo_uploaded: 'Logo uploadet',
    logo_upload_failed: 'Logoet kunne ikke uploades',
    logo_removed: 'Logo fjernet',
    logo_remove_failed: 'Logoet kunne ikke fjernes',
    file_too_large: 'Filen er for stor. Maksimal størrelse er {{max}} MB.',
    image_too_narrow: 'Loginbilledet skal være mindst {{min}} px bredt.',
  },
  notification_channels: {
    master_locked: 'Masterpartneren sender for alle platformens restauranter, så dens kanaler kan ikke ændres her.',
    unavailable: 'Notifikationskanaler er endnu ikke tilgængelige på denne backend.',
    notice:
      "Intern indstilling. En partner uden sin egen Twilio-konto skal forblive kun på e-mail: ellers ville hver SMS, WhatsApp-besked og telefonopkald blive sendt via FoodAmigos' Twilio-konto.",
    forbidden: 'Kun superadministratorer kan ændre notifikationskanaler.',
    columns: {
      channel: 'Kanal',
      status: 'Aktiveret',
    },
    channels: {
      email: {
        name: 'E-mail',
        description: 'Altid aktiv, så partneren og dens restauranter altid kan kontaktes.',
      },
      sms: {
        name: 'SMS',
        description: 'Ordreopdateringer og logink​oder til gæster via sms.',
      },
      whatsapp: {
        name: 'WhatsApp',
        description: 'Beskeder til restaurantejere og logink​oder til gæster på WhatsApp.',
      },
      voice_call: {
        name: 'Taleopkald',
        description: 'Påmindelsesopkald om afventende bestillinger og telefonbesvarelse.',
      },
      push: {
        name: 'Push-notifikationer',
        description:
          'Push-notifikationer til gæster og til ejerens dashboard-app. Personalets tabletalarmer påvirkes ikke.',
      },
    },
    toasts: {
      load_error: 'Notifikationskanalerne kunne ikke indlæses.',
      error: 'Notifikationskanalerne kunne ikke gemmes.',
      saved: 'Notifikationskanaler gemt.',
    },
  },
  feature_flags: {
    internal_notice: 'Kun til FoodAmigos. Ikke synligt for partneren. Ændringer træder i kraft med det samme.',
    read_only:
      'Skrivebeskyttet – ændring af restaurantfakturering kræver en koordineret udrulning, ikke en kontakt. Tal med udviklingsteamet.',
    forbidden: 'Kun superadministratorer kan administrere partnerens funktionsflag.',
    columns: {
      feature: 'Funktion',
      status: 'Status',
    },
    flags: {
      external_printer: {
        name: 'Ekstern kvitteringsprinter',
        description:
          'Standarden for restauranter, som denne partner onboarder fra nu af: hver ny restaurant kan fra start tilslutte en netværkskvitteringsprinter til bestillingsterminal-appen. Eksisterende restauranter beholder det, deres egen fane Funktionsflag angiver, og hver restaurant kan stadig skiftes individuelt der.',
      },
      plg_onboarding: {
        name: 'Selvbetjent onboarding (PLG)',
        description:
          'Selvbetjent partner-onboarding: giver denne partner den guidede side Ny restaurant og onboarding-guiden i stedet for den klassiske Tilføj virksomhed-modal og Kom i gang-stepper, skjuler flader, der kun er til FoodAmigos eller endnu ikke er relevante, for partneren og dens restauranter, og blokerer den første go-live, indtil en lanceringsdato er aftalt. Aktiveret for alle nye partnere.',
      },
      issue_end_customer_receipts: {
        name: 'Fakturaer til slutkunder',
        description:
          'Lader gæster anmode om en faktura ved betaling og modtage den på e-mail. Deaktiveret for nye partnere; internationale regler for fakturaformat gør det dyrt at understøtte.',
      },
      merchant_billing: {
        name: 'Restaurantfakturering',
        description: 'Fakturerer partnerens restauranter via platformen. Fra betyder, at de afregner uden for den.',
      },
      cuisine_backfill: {
        name: 'Efterfyldning af køkkentyper',
        description: 'Tillader, at den automatiske efterfyldning af køkkentyper kører for denne partners restauranter.',
      },
      image_backfill: {
        name: 'Efterfyldning af billeder',
        description:
          'Tillader, at den automatiske efterfyldning af menubilleder kører for denne partners restauranter.',
      },
      auto_image_generation: {
        name: 'Automatisk billedgenerering',
        description: 'Genererer menubilleder efter behov for denne partners restauranter.',
      },
      provider_billing: {
        name: 'Partnerfakturering via Foodamigos',
        description:
          "Inkluderer denne partner i Foodamigos' faktureringskørsel. Fra betyder, at partneren faktureres uden for platformen. Slår også PayPal (direkte) til for denne partners restauranter, med servicegebyr opkrævet på det.",
      },
      partner_custom_dashboard_domain: {
        name: 'Eget dashboard-domæne',
        description:
          'Lader denne partner tilslutte sit eget domæne til dashboardet, så dens team og restauranter logger ind under partnerens adresse. Når du slår det til eller fra, flyttes alle dashboard-links, som platformen sender for denne partner.',
      },
      partner_custom_shop_domain: {
        name: 'Eget shopdomæne',
        description:
          'Lader denne partner tilslutte sit eget domæne til sine restauranters onlineshops, hvor hver restaurant får sin egen adresse. Åbn det for én partner ad gangen: det ændrer den adresse, kunderne bruger.',
      },
      partner_legal_documents: {
        name: 'Juridiske dokumenter for partner',
        description:
          'Genererer kolofon, privatlivspolitik og vilkår til denne partners restaurantshops ud fra hver restaurants egne juridiske oplysninger. Når det er fra, eller mens en restaurants oplysninger er ufuldstændige, viser shops platformens standarddokumenter.',
      },
    },
    toasts: {
      load_error: 'Funktionsflagene kunne ikke indlæses',
      error: 'Funktionsflaget kunne ikke ændres',
      enabled: 'Funktion aktiveret',
      disabled: 'Funktion deaktiveret',
    },
  },
};
